import { RouteConfig } from 'vue-router';
import MswPrefFileDownload from './msw-pref-file-download-report.vue';
import MswPrefFileDownloadReportPrint from './msw-pref-file-download-report-print.vue';

const route: RouteConfig = {
  path: 'pref-file-download-report',
  component: MswPrefFileDownload,
};

export const printRoute: RouteConfig = {
  path: 'print-preference-file-download-report',
  component: MswPrefFileDownloadReportPrint,
};

export default route;
